// components/video-player.js
export function initVideoPlayer() {
  const videos = document.querySelectorAll('.video-element');
  
  videos.forEach(video => {
    const loadingDiv = video.parentNode.querySelector('.video-loading');
    const playOverlay = video.parentNode.querySelector('.video-play-overlay');
    const playButton = video.parentNode.querySelector('.video-play-button');
    
    // Initially hide loading state and show play button
    if (loadingDiv) loadingDiv.style.display = 'none';
    if (playOverlay) playOverlay.style.display = 'flex';
    video.classList.add('loaded');
    
    // Show loading only if video fails to load
    video.addEventListener('loadstart', function() {
      if (loadingDiv) loadingDiv.style.display = 'block';
      if (playOverlay) playOverlay.style.display = 'none';
    });
    
    // Hide loading and show play button when video can play
    video.addEventListener('canplay', function() {
      if (loadingDiv) loadingDiv.style.display = 'none';
      if (playOverlay) playOverlay.style.display = 'flex';
      video.classList.add('loaded');
    });
    
    // Handle loading errors
    video.addEventListener('error', function() {
      if (loadingDiv) {
        loadingDiv.innerHTML = '<p>Video failed to load. Please try again.</p>';
        loadingDiv.style.display = 'block';
      }
      if (playOverlay) playOverlay.style.display = 'none';
    });
    
    // Play overlay click handler
    if (playOverlay) {
      playOverlay.addEventListener('click', function() {
        video.controls = true;
        video.play();
        playOverlay.style.display = 'none';
      });
    }
    
    // Play button click handler
    if (playButton) {
      playButton.addEventListener('click', function(e) {
        e.stopPropagation();
        video.controls = true;
        video.play();
        if (playOverlay) playOverlay.style.display = 'none';
      });
      
      // Keyboard support
      playButton.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          video.controls = true;
          video.play();
          if (playOverlay) playOverlay.style.display = 'none';
        }
      });
    }
    
    // Hide play overlay when video starts playing
    video.addEventListener('play', function() {
      if (playOverlay) playOverlay.style.display = 'none';
    });
    
    // Show play overlay when video is paused
    video.addEventListener('pause', function() {
      if (playOverlay && !video.ended) {
        playOverlay.style.display = 'flex';
      }
    });
  });
}